import { createSlice, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios';
import BaseUrl from '../../../assets/utils/accessToken'
const initialState = {

  IndexResearchConfigs: [],
  IndexResearchConfigsStatus: 'idle',
  IndexResearchConfigsByType: [],
  IndexResearchConfigsByTypeStatus: 'idle',
  IndexResearchConfig: null,
  IndexResearchConfigStatus: 'idle',

}

export const fetchIndexConfigs = createAsyncThunk('indexConfig/fetchIndexConfigs', async (id, { rejectWithValue }) => {
  try {

    const token = localStorage.getItem('token')
    const response = await axios.get(BaseUrl + '/indexResearch/',
      {
        headers: {
          'Authorization': `Token ${token}`
        }
      }

    )
    //console.log(response.data, 'response.data')
    return response.data

  } catch (err) {
    let error = err
    if (!error.response) {
      throw err
    }

    return rejectWithValue(error.response)
  }
})

export const addIndexConfig = createAsyncThunk(
  'indexConfig/addIndexConfig',
  async (toAddActivity, { rejectWithValue }) => {

    try {
      const token = localStorage.getItem('token')
      const response = await axios.post(BaseUrl + `/indexResearch/create/`, toAddActivity, {
        headers: {
          'Authorization': `token ${token}`
        }
      })
      return response.data
    } catch (err) {
      let error = err
      if (!error.response) {
        throw err
      }

      return rejectWithValue(error.response)
    }
  }
)

export const deleteIndexConfig = createAsyncThunk(
  'indexConfig/deleteIndexConfig',
  async (id, { rejectWithValue }) => {

    try {
      const token = localStorage.getItem('token')
      const response = await axios.delete(BaseUrl + `/indexResearch/${id}/delete/`, {
        headers: {
          'Authorization': `token ${token}`
        }
      })
      return response.data
    } catch (err) {
      let error = err
      if (!error.response) {
        throw err
      }

      return rejectWithValue(error.response)
    }
  }
)

const indexConfigSlice = createSlice({
  name: 'indexConfig',
  initialState,
  extraReducers: {

    [fetchIndexConfigs.pending]: (state, action) => {
      state.IndexResearchConfigsStatus = 'loading'
    },
    [fetchIndexConfigs.fulfilled]: (state, action) => {
      state.IndexResearchConfigsStatus = 'succeeded'

      state.IndexResearchConfigs = action.payload
    },
    [fetchIndexConfigs.rejected]: (state, action) => {
      state.IndexResearchConfigsStatus = 'failed'
      if (action.payload) {
        state.error = action.payload
      } else {
        state.error = action.error
      }
    },

  },

})

export default indexConfigSlice.reducer

